module.exports = __webpack_public_path__ + "static/media/ZoneC.6e670199.png";